import { memo } from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

const Privacy: React.FC = memo(() => {
  const { t } = useTranslation()
  return (
    <p className="mt-11 text-center text-dark-neutral-200 text-xs">
      <Link
        data-testid="privacy-policy-link"
        to="https://www.napster.com/privacy-policy"
        className="underline"
        target="_blank"
        rel="noopener noreferrer"
      >
        {t('twin.privacyPolicy')}
      </Link>
      &nbsp;&&nbsp;
      <Link
        data-testid="terms-link"
        to="https://www.napster.com/terms-of-service"
        className="underline"
        target="_blank"
        rel="noopener noreferrer"
      >
        {t('twin.terms')}
      </Link>
      .
    </p>
  )
})

export { Privacy }
